import React from 'react';
import styles from './Chapters.css';

const CHAPTERS = [
    'Childhood & roots',
    'Where it all began',
    'School days',
    'Coming of age',
    'On my own',
    'Building a family',
    'The life I built'
];

function Chapters() {
    return (
        <section className={styles.chaptersSection}>
            <h2 className={styles.chaptersTitle}>A life, told chapter by chapter</h2>
            <p className={styles.chaptersSubtitle}>Start with what feels meaningful today. New questions are added regularly.</p>
            <ul className={styles.chaptersList}>
                {CHAPTERS.map(chapter => (
                    <li key={chapter} className={styles.chaptersItem}>{chapter}</li>
                ))}
            </ul>
        </section>
    );
}

export {
    Chapters
};
